import { PDropdown } from 'components/prime/PDropdown/PDropdown';
import { useObservableState } from 'observable-hooks';
import React from 'react';
import { useUploadStepBLoC } from '../../../../UploadStep.bloc';
import { TypeOfDataIndustryDropdownStyle as S } from './TypeOfDataIndustryDropdown.style';
import { FormField } from 'components/FormField/FormField';

export const TypeOfDataIndustryDropdown: React.FC = () => {
  const { uploadForm, $industries } = useUploadStepBLoC();
  const industries = useObservableState($industries, []);

  return (
    <S.Container>
      <FormField
        form={uploadForm}
        controller={{
          name: 'industryId',
          rules: {
            required: 'Industry is required',
          },
        }}
        label="Industry"
      >
        {({ field, fieldState }) => (
          <>
            <PDropdown
              {...field}
              options={industries}
              optionValue="id"
              optionLabel="name"
              placeholder="Select an option"
              invalid={fieldState.invalid}
            />
          </>
        )}
      </FormField>
    </S.Container>
  );
};
